export default {
  companyUrl: 'https://dev-next-www.lwtears.com',
  digitalAssetsUrl: 'https://a-z-educator-content-dev-next.s3.amazonaws.com',
};
